/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchVideoModelDto } from '../../models/match-video-model-dto';

export interface MatchVideoControllerGetMatchVideos$Params {
}

export function matchVideoControllerGetMatchVideos(http: HttpClient, rootUrl: string, params?: MatchVideoControllerGetMatchVideos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MatchVideoModelDto>>> {
  const rb = new RequestBuilder(rootUrl, matchVideoControllerGetMatchVideos.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MatchVideoModelDto>>;
    })
  );
}

matchVideoControllerGetMatchVideos.PATH = '/match-videos';
